export default __webpack_public_path__ + "static/media/loai.75d10355.webp";